<template>
  <div>
    <div class="modal-header has-background-info-light">
      <h2 class="window-header subtitle">{{ title }}</h2>
    </div>
    <div>
      {{ text }}
    </div>

    <!-- Buttons -->
    <div class="columns">
      <div class="column">
        <button class="button is-info is-light is-rounded" @click="okClicked">
          OK
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Info",

  props: {
    title: String,
    text: String,
  },

  data() {
    return {};
  },

  mounted() {},

  methods: {
    okClicked() {
      console.log("jedan");
      this.$emit("okClicked");
    },
  },
};
</script>
